module.exports = __webpack_public_path__ + "static/media/global_earth.acfeeb64.png";